import { createReducer, on } from "@ngrx/store";
import { initialEmpForm } from "./states";
import { allEmployeeFields} from "./actions";

export const employeeReducer = createReducer(
  initialEmpForm,

  on(allEmployeeFields, (state, { allEmployeeFields }) => ({
    ...state,
    Employeeform: allEmployeeFields
  })),

);

